const contentful = require("contentful");

const client = contentful.createClient({
    space: "mpv57fg6oz3w",
    accessToken: "zkL3zFZ3w3ZmjdOUSPzJrl-CcucBME9r2ove-FB2_5E",
    environment: "master"
});

const contentHelper = {
    client: client
};

module.exports = contentHelper;
